import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import './style.css';
import ReactComponent from "../ReactComponent";
import {
	Table,
	Button,
	Spin,
	Icon,
	Form,
	Input,
	DatePicker,
	TreeSelect,
	Select,
} from 'antd';
import attendanceRecordService from '../../services/Attendance/attendance-record-service';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';
const webConfig = require('../../config.json');


class AttendanceMonthlyRecord extends ReactComponent {

	dataMode = 1
	state = {

		filters: {
			current_record_date: "",
			department_id: "",
			real_name: "",
			job_number: "",
			page: 1,
		},
		data: [],
		dataStatus: "unload",

	}

	actions = {
		selectAction: attendanceRecordService.selectAttendanceMonthlyRecord,
		exportAction: attendanceRecordService.exportAttendanceMonthlyRecord,
	}

	customComponentWillMount() {
		this.props.fetchDepartmentsList();

	}

	setMonthFilter = (moment, date) => {
		this.setState({
			filters: {
				...this.state.filters,
				current_record_date: date,
				page: 1
			}
		})
	}

	setPageFilter = pagination => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			page: pagination.current
		}
	}, this.reloadAction)

	setEmployeeFilter = value => this.setState({
		dataStatus: "loading",
		filters: {
			...this.state.filters,
			real_name: value,
			job_number: value
		}
	}, this.reloadAction)

	setDepartmentFilter = value => this.setState({
		filters: {
			...this.state.filters,
			department_id: value + ""
		}
	})
	//切换校区
	setCampusFilter = value => {
		this.setState({
			filters: {
				...this.state.filters,
				campus: value + "",
				department_id:null
			}
		})
		//加载当前校区下的部门
		this.props.fetchDepartmentsList({ campus: value });
	}
	setChangeEmployeeFilter = event => {
		if (!event.target.value) {
			//this.setEmployeeFilter();
		}
	}

	exportAttendance = () => {
		let gets = {};
		Object.keys(this.state.filters).forEach(key => {
			if (this.state.filters[key]) {
				gets[key] = this.state.filters[key];
			}
		});
		delete gets.page;
		this.publicExport(gets);
	}

	renderTreeNodes = data => data.map(item => {
		if (item.children) {
			return (
				<TreeSelect.TreeNode title={item.name}
					value={item.id + ""}
					key={item.id}
					dataRef={item}>
					{this.renderTreeNodes(item.children)}
				</TreeSelect.TreeNode>
			);
		}
		return <TreeSelect.TreeNode {...item} />
	})

	render() {
		console.log(this.state.data)
		const column = [{
			title: '工号',
			dataIndex: 'job_number',
			key: 'job_number',
			className: "table-global-head"
		}, {
			title: '姓名',
			dataIndex: 'employee_name',
			key: 'employee_name',
			className: "table-global-head",
			render: (text, record) => {
				return (
					<Link to={"/attendance/attendance-monthly-record-detail/" + record.employee_id + "/" + record.management_date + "/" + record.employee_name + "/" + record.department_name}>
						{text}
					</Link>
				)
			}
		}, {
			title: '部门',
			dataIndex: 'department_name',
			key: 'department_name',
			className: "table-global-head"
		}, {
			title: '状态',
			dataIndex: 'status',
			key: 'status',
			className: "table-global-head"
		},
		//   {
		// 			title: '审核情况',
		// 			dataIndex: 'audit_info',
		// 			key: 'audit_info',
		// 			className: "table-global-head"
		// 		},
		{
			title: '是否全勤',
			dataIndex: 'all_attendance',
			key: 'all_attendance',
			className: "table-global-head"
		},
		{
			title: '应出勤天数',
			dataIndex: 'should_attendance_count',
			key: 'should_attendance_count',
			className: "table-global-head"
		}, {
			title: '实际出勤天数',
			dataIndex: 'actual_attendance_count',
			key: 'actual_attendance_count',
			className: "table-global-head"
		}, {
			title: '普通加班',
			dataIndex: 'ordinary_overtime',
			key: 'ordinary_overtime',
			className: "table-global-head"
		}, {
			title: '因公加班',
			dataIndex: 'public_overtime',
			key: 'public_overtime',
			className: "table-global-head"
		}, {
			title: '普通加班剩余',
			dataIndex: 'left_common_work_hours',
			key: 'left_common_work_hours',
			className: "table-global-head"
		}, {
			title: '因公加班剩余',
			dataIndex: 'left_formal_work_hours',
			key: 'left_formal_work_hours',
			className: "table-global-head"
		},
		{
			title: '未打卡次数',
			dataIndex: 'no_punch_count',
			key: 'no_punch_count',
			className: "table-global-head"
		},
		{
			title: '调休假',
			dataIndex: 'relaxation',
			key: 'relaxation',
			className: "table-global-head"
		}, {
			title: '事假',
			dataIndex: 'personal_leave_count',
			key: 'personal_leave_count',
			className: "table-global-head"
		}, {
			title: '病假',
			dataIndex: 'sick_count',
			key: 'sick_count',
			className: "table-global-head"
		},
		{
			title: '年假(天)',
			dataIndex: 'year_vacation_count',
			key: 'sickyear_vacation_countcount',
			className: "table-global-head"
		},
		//   {
		// 			title: '迟到次数',
		// 			dataIndex: 'late_count',
		// 			key: 'late_count',
		// 			className: "table-global-head"
		// 		},
		{
			title: '迟到次数',
			children: [
				{
					title: '1-9分钟',
					dataIndex: 'late_count1',
					key: 'late_count1',
					className: "table-global-head"
				}, {
					title: '10-31分钟',
					dataIndex: 'late_count2',
					key: 'late_count2',
					className: "table-global-head"
				}, {
					title: '31-60分钟',
					dataIndex: 'late_count3',
					key: 'late_count3',
					className: "table-global-head"
				}, {
					title: '61-120分钟',
					dataIndex: 'late_count4',
					key: 'late_count4',
					className: "table-global-head"
				}, {
					title: '120分钟以上',
					dataIndex: 'late_count5',
					key: 'late_count5',
					className: "table-global-head"
				}
			]
		},
		//   {
		// 			title: '早退次数',
		// 			dataIndex: 'leave_early_count',
		// 			key: 'leave_early_count',
		// 			className: "table-global-head"
		// 		},
		{
			title: '早退次数',
			children: [
				{
					title: '1-15分钟',
					dataIndex: 'leave_early_count1',
					key: 'leave_early_count1',
					className: "table-global-head"
				}, {
					title: '16-60分钟',
					dataIndex: 'leave_early_count2',
					key: 'leave_early_count2',
					className: "table-global-head"
				}, {
					title: '60分钟以上',
					dataIndex: 'leave_early_count3',
					key: 'leave_early_count3',
					className: "table-global-head"
				}
			]
		},
		//   {
		// 			title: '出差',
		// 			dataIndex: 'business_trip_count',
		// 			key: 'business_trip_count',
		// 			className: "table-global-head"
		// 		},
		{
			title: '旷工次数',
			dataIndex: 'stayaway_count',
			key: 'stayaway_count',
			className: "table-global-head"
		},
		{
			title: '产假',
			dataIndex: 'maternity_count',
			key: 'maternity_count',
			className: "table-global-head"
		}, {
			title: '工伤假',
			dataIndex: 'industrial_injury_count',
			key: 'industrial_injury_count',
			className: "table-global-head"
		}, {
			title: '丧假',
			dataIndex: 'funeral_leave_count',
			key: 'funeral_leave_count',
			className: "table-global-head"
		}, {
			title: '看护假',
			dataIndex: 'paternity_leave_count',
			key: 'paternity_leave_count',
			className: "table-global-head"
		}
		];
		return (
			<div className="app-module-item">
				<div style={{ marginBottom: "20px" }}>

					<div className="colAction" style={{ float: "left", margin: "0px 10px 10px 0px" }}>
						<Button type="primary" onClick={this.exportAttendance}>
							<Icon type="cloud-upload-o" />
							<span>导出</span>
						</Button>
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<Input.Search
							placeholder="报告人 工号/姓名"
							onSearch={this.setEmployeeFilter}
							onChange={this.setChangeEmployeeFilter}
							style={{ width: 200 }}
							defaultValue={null}
							enterButton />
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>选择月份 : </span>
						<DatePicker onChange={this.setMonthFilter}
							placeholder="请选择月份"
							format="YYYY-MM"
							value={this.state.filters.current_record_date ?
								moment(this.state.filters.current_record_date) : null} />
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<TreeSelect style={{ minWidth: "300px" }}
							placeholder="请选择部门"
							showSearch={false}
							autoExpandParent={true}
							dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
							treeDefaultExpandAll
							value={this.state.filters.department_id}
							onChange={this.setDepartmentFilter}>
							{
								this.props.departmentStructure.departmentsList
								&& this.renderTreeNodes(this.props.departmentStructure.departmentsList)
							}
						</TreeSelect>

					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<span style={{ marginRight: "5px" }}>校区 : </span>
						<Select style={{ width: "300px" }} onChange={this.setCampusFilter}>
							<Select.Option key={0} value={0}></Select.Option>
							<Select.Option key={1} value={1}>{'华山校HS'}</Select.Option>
							<Select.Option key={2} value={2}>{'中星城校ZXC'}</Select.Option>
							<Select.Option key={3} value={3}>{'时光里校SGL'}</Select.Option>
							<Select.Option key={4} value={4}>{'晶耀前滩校JYC'}</Select.Option>
						</Select>
					</div>
					<div style={{ clear: "both" }}></div>
				</div>
				<div>
					{(() => {
						switch (this.state.dataStatus) {
							case "loaded":
								return (
									<Table columns={column}
										dataSource={this.state.data.Data}
										scroll={{ x: 800 }}
										rowKey={(record, index) => index}
										pagination={{
											total: this.state.data.Total,
											pageSize: this.state.data.PageSize,
											current: this.state.filters.page
										}}
										onChange={this.setPageFilter} />)
							case "error":
								return (
									<div style={{ textAlign: 'center', margin: '100px 0px' }}>
										{webConfig.httpFetchErrorInformation}
									</div>);
							case "loading":
							case "reload":
							case "unload":
								return (
									<div style={{ textAlign: 'center', margin: '100px 0px' }}>
										<Spin size="large" />
									</div>);
							default:
								return null;
						}
					})()}
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure
	}
}

const mapDispatchToProps = {
	fetchDepartmentsList
}

AttendanceMonthlyRecord = Form.create()(AttendanceMonthlyRecord)

export default connect(mapStateToProps, mapDispatchToProps)(AttendanceMonthlyRecord);









// WEBPACK FOOTER //
// ./src/routes/Attendance/AttendanceMonthlyRecord.js